import { useEffect } from 'react';

const LOGIN_PATH = '/login';

/**
 * Manda el navegador a `/login` con una navegación real, no con el router.
 *
 * En premanager/manager el mismo host lo reparte el ingress entre las dos
 * aplicaciones y `/login` es de sporttia-competitions. Con `<Navigate>` no se
 * pide nada al servidor, así que el gestor se quedaba pintando su propio login
 * con la URL cambiada; saliendo por `window.location` decide el borde quién
 * sirve la página. En local, donde no hay ingress, la sirve el propio gestor.
 */
export default function RedirectToLogin(): null {
    useEffect(() => {
        // Si ya se está en el login no se navega: evita recargas en bucle
        // cuando es el propio gestor quien sirve esa ruta.
        if (window.location.pathname === LOGIN_PATH) return;

        window.location.replace(LOGIN_PATH);
    }, []);

    return null;
}
